import React, { useState } from 'react';

const MenuList = ({ menus, onEdit }) => {
  const [search, setSearch] = useState('');

  const filteredMenus = menus.filter((menu) =>
    menu.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="max-w-5xl bg-white rounded shadow p-6 mx-auto">
      <h2 className="text-xl font-semibold mb-4">Menus</h2>

      <input
        type="text"
        placeholder="Search menus..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full px-4 py-2 border rounded mb-4"
      />

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 text-left">Name</th>
            <th className="p-2 text-left">Price</th>
            <th className="p-2 text-left">Type</th>
            <th className="p-2 text-left">Pod</th>
            <th className="p-2 text-left">Meal Type</th>
          </tr>
        </thead>
        <tbody>
          {filteredMenus.map((menu) => (
            <tr
              key={menu.id}
              onClick={() => onEdit(menu)}
              className="cursor-pointer hover:bg-gray-50 border-t"
            >
              <td className="p-2">{menu.name}</td>
              <td className="p-2">{menu.price}</td>
              <td className="p-2">{menu.menutype}</td>
              <td className="p-2">{menu.pod?.podname || '—'}</td>
              <td className="p-2">{menu.mealtype?.type || '—'}</td>
              <td className="p-2">
                {menu.menuImages?.[0]?.imageUrl ? (
                    <img
                    src={menu.menuImages[0].imageUrl}
                    alt={menu.name}
                    className="w-12 h-12 object-cover rounded"
                    />
                ) : (
                    <span className="text-gray-400 italic">No image</span>
                )}
                </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MenuList;
